import React from 'react';
import { PageLayout } from './PageLayout';

export const ImpressumPage = () => {
    return (
        <PageLayout title="Impressum">
            <h3 className="text-xl font-semibold mt-0">Angaben gemäß § 5 TMG</h3>
            <p>
                DetoxTeeTest.com<br />
                Friedrichstraße 147<br />
                10117 Berlin<br />
                Deutschland
            </p>

            <h3 className="text-xl font-semibold mt-8">Kontakt</h3>
            <p>
                E-Mail: info@detoxteetest.com
            </p>

            <h3 className="text-xl font-semibold mt-8">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
            <p>
                DetoxTeeTest.com<br />
                Friedrichstraße 147<br />
                10117 Berlin
            </p>

            <h3 className="text-xl font-semibold mt-8">Haftung für Inhalte</h3>
            <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
                allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch 
                nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach 
                Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p>
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen 
                Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt 
                der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden 
                Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>

            <h3 className="text-xl font-semibold mt-8">Haftung für Links</h3>
            <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss 
                haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte 
                der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
            <p>
                Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. 
                Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente 
                inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer 
                Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige 
                Links umgehend entfernen.
            </p>

            <h3 className="text-xl font-semibold mt-8">Urheberrecht</h3>
            <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem 
                deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung 
                außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen 
                Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht 
                kommerziellen Gebrauch gestattet.
            </p>
            <p>
                Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte 
                Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie 
                trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden 
                Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>

            <h3 className="text-xl font-semibold mt-8">Affiliate-Hinweis</h3>
            <p>
                Diese Website enthält Affiliate-Links. Bei einem Kauf über diese Links erhalten wir möglicherweise 
                eine Provision. Für Sie entstehen dabei keine zusätzlichen Kosten. Unsere Produktbewertungen und 
                Empfehlungen werden dadurch nicht beeinflusst. Wir sind bestrebt, Ihnen stets unabhängige und 
                objektive Informationen zu liefern.
            </p>

            <h3 className="text-xl font-semibold mt-8">Streitschlichtung</h3>
            <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline ml-1">
                    https://ec.europa.eu/consumers/odr/
                </a>
            </p>
            <p>
                Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder verpflichtet, 
                an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
        </PageLayout>
    );
};

